import { render, staticRenderFns } from "./SetRelatedProjectDialog.vue?vue&type=template&id=2a8b7828&scoped=true&"
import script from "./SetRelatedProjectDialog.vue?vue&type=script&lang=js&"
export * from "./SetRelatedProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./SetRelatedProjectDialog.vue?vue&type=style&index=0&id=2a8b7828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b7828",
  null
  
)

export default component.exports